import {useRef, useState} from "react";
import {Optional} from "../utils/types.ts";

export default function useAudioRecording() {
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [recordingDate, setRecordingDate] = useState<Optional<Date>>(null);
  const audioChunks = useRef<Blob[]>([]);
  const mediaRecorder = useRef<Optional<MediaRecorder>>(null);
  const mediaStream = useRef<Optional<MediaStream>>(null);
  
  return {
    isRecording,
    setIsRecording,
    isPaused,
    setIsPaused,
    audioChunks,
    mediaRecorder,
    mediaStream,
    setRecordingDate,
    recordingDate
  };
}